import { Avatar } from '@pickleballinc/ui/components/ui/avatar';
import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { EventsBreakdown } from '@/modules/rankings/PlayerCard/EventsBreakdown';
import { HiddenAge } from '@/modules/rankings/PlayerCard/HiddenAge';
import { formatPoints } from '@/modules/rankings/rankingsUtils';

interface SmallNonLiveProps {
  rank: string;
  fullName: string;
  country: string;
  avatarUrl: string;
  flagUrl: string;
  age: string;
  played: number;
  doublesPlayed: number;
  mixedPlayed: number;
  singlesPlayed: number;
  gender: string;
  isCurrentSeed: boolean;
  points: number;
  change: number;
  playerRedirectURL: string;
}

export const SmallNonLive = ({
  rank,
  fullName,
  country,
  avatarUrl,
  flagUrl,
  age,
  played,
  doublesPlayed,
  mixedPlayed,
  singlesPlayed,
  gender,
  isCurrentSeed,
  points,
  playerRedirectURL,
}: SmallNonLiveProps) => {
  return (
    <div className='container ml-0 flex w-full items-center justify-center border-b border-gray-200 p-0'>
      <div className='flex w-[6%] items-center justify-start pl-3 text-sm font-semibold'>
        {rank}
      </div>
      <CustomLink
        href={playerRedirectURL}
        className='flex w-[44%] items-center justify-start space-x-3 overflow-hidden rounded-full'
      >
        <Avatar name={fullName} src={avatarUrl || undefined} size='xs' variant='gray' />
        <span className='flex flex-row gap-1'>
          <p className='text-sm font-semibold text-gray-900'>{fullName}</p>
        </span>
      </CustomLink>
      <div className='flex w-[10%] items-center justify-start space-x-3'>
        <ImageWithFallback
          src={flagUrl ? flagUrl : undefined}
          className='fill size-[18px] rounded-full'
          alt={`${country} flag`}
          width={18}
          height={18}
        />
        <span className='text-sm font-semibold text-gray-900'>{country}</span>
      </div>
      <div className='flex w-[10%] items-center justify-center text-sm text-gray-900'>
        {age === '-1' ? <HiddenAge /> : age}
      </div>
      <div className='flex w-[15%] flex-col items-center justify-center text-sm text-gray-900'>
        <span>{played}</span>
        {!isCurrentSeed ? (
          <EventsBreakdown
            doubles={doublesPlayed}
            mixed={mixedPlayed}
            singles={singlesPlayed}
            gender={gender}
            className='mt-0.5 flex gap-x-2 whitespace-nowrap text-xs text-gray-500'
          />
        ) : null}
      </div>
      <div className='flex w-[15%] items-center justify-center text-sm font-semibold text-brand-700'>
        {formatPoints(points)}
      </div>
    </div>
  );
};
